"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rarities = void 0;
const schemas_1 = require("@dcl/schemas");
const abis_1 = require("../abis");
exports.rarities = {
    [schemas_1.ChainId.MATIC_MUMBAI]: {
        version: '1',
        abi: abis_1.abis.Rarities,
        address: '0x8eabF06f6cf667915bfF30138be70543bCE2901A',
        name: 'Decentraland Rarities',
        chainId: schemas_1.ChainId.MATIC_MUMBAI
    },
    [schemas_1.ChainId.MATIC_MAINNET]: {
        version: '1',
        abi: abis_1.abis.Rarities,
        address: '0x17113b44fdd661A156cc01b5031E3aCF72c32EB3',
        name: 'Decentraland Rarities',
        chainId: schemas_1.ChainId.MATIC_MAINNET
    }
};
//# sourceMappingURL=rarities.js.map